module.exports = __webpack_public_path__ + "static/media/data-tooltip-3.e65f63af.png";